import SSOTokenSemCadastroDto from '../dto/SSOTokenSemCadastroDto';

export default class SSOTokenSemCadastro {
  primeiroNome: string;
  dataNascimento: Date;
  credor: string;
  dividaId: number;

  constructor(src: SSOTokenSemCadastroDto) {
    this.primeiroNome = src.primeiroNome;
    this.dataNascimento = new Date(src.dataNascimento);
    this.credor = src.credor;
    this.dividaId = src.dividaId;
  }
}
